module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-labor-ebfe68812a079b7ca81873c1be33634e.svg";